import request from '@/utils/request'
import { downloadBlob } from '@/utils/download'
const apiPath = '/sys/yongyouConfig'
const yongyouConfigApi = {
  /**
   * 新增【用友账套管理】
   */
  create(data) {
    return request.post(apiPath, data)
  },
  /**
   * 修改【用友账套管理】
   */
  update(data) {
    return request.post(apiPath + '/updatediy', data)
  },
  addOrUpdateConfig(data) {
    return request.post(apiPath + '/addOrUpdateConfig', data)
  },
  /**
   * 分页查询【用友账套管理】
   */
  fetchList(query) {
    return request.get(apiPath + '/listdiy', { params: query })
  },
  /**
   * 查询【用友账套管理】选项列表
   */
  findOptions(query) {
    return request.get(`${apiPath}/options`, { params: query })
  },
  /**
   * 查看【用友账套管理】详情
   */
  fetchById(id) {
    return request.get(`${apiPath}/${id}`)
  },
  /**
   * 删除单个【用友账套管理】
   */
  deleteById(id) {
    return request.delete(`${apiPath}/${id}`)
  },
  /**
   * 批量删除【用友账套管理】
   */
  deleteBatch(ids) {
    return request.delete(apiPath, { data: ids })
  },
  setIsEnable(data) {
    return request.post(apiPath + '/updatediy2', data, { isFormData: 1 })
  },
  configPayList(query) {
    return request.get(apiPath + '/configPayList', { params: query })
  },
  addOrUpdateConfigPay(data) {
    return request.post(apiPath + '/addOrUpdateConfigPay', data)
  },
  UpdateConfigPayState(query) {
    return request.get(apiPath + '/UpdateConfigPayState', { params: query })
  },
  /**
   * 导出全部通商云商户号（BUG-2026-370483 / REQ-2026-751517）。
   *
   * ⚠️ 数据源是 `yongyou_config_pay`（本页「支付配置」那张表），
   * **不是 `pay_merchant`**。这两张表都叫"商户号"但完全不是一回事：
   * pay_merchant 是通联/微信的支付商户（生产 4 条），归 payMerchant.vue 那个页面管。
   * 之前这三个按钮错接了 payMerchantApi，导出只有 4 行、列也是另一套。
   *
   * 后端不分页、导全量，所以**不传任何筛选参数**。
   */
  configPayExport() {
    return request.get(`${apiPath}/configPay/export`, { responseType: 'blob' })
      // 文件名以响应头 filename*=utf-8'' 为准（downloadBlob 优先用它），
      // 这里只是响应头缺失时的兜底，要与后端的 exportName 保持一致
      .then(res => downloadBlob(res, '城市公司通商云商户号.xlsx'))
  },
  /**
   * 下载通商云商户号导入模板（列与 configPayImport 的解析一一对应）
   */
  configPayTemplate() {
    return request.get(`${apiPath}/configPay/template`, { responseType: 'blob' })
      .then(res => downloadBlob(res, '通商云商户号导入模板.xlsx'))
  },
  /**
   * 批量导入通商云商户号。
   * 返回 { total, insertCount, updateCount, failCount, failReasons[] }，
   * 逐行失败原因要摊给运营看，不能只提示"导入失败"。
   */
  configPayImport(formData) {
    return request.post(`${apiPath}/configPay/import`, formData)
  },
}
export default yongyouConfigApi
